import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'

import LessonCodes from 'views/modals/lesson_codes_modal'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import binderActions from 'redux/actions/binderActions'
import modalTypes from 'helpers/enums/modalTypes'

class BinderLessonCodesModal extends React.Component {

	render() {
		return (
			<LessonCodes
				closeModal={this.props.actions.closeModal}
				modalName={modalTypes.BINDERS_LESSON_CODES}
				codes={this.props.codes}
				dateFormat={this.props.dateFormat}
				timeFormat={this.props.timeFormat}
				actualTimestamp={this.props.actualTimestamp}
			/>
		)
	}
}

BinderLessonCodesModal.propTypes = {
	binderUID: PropTypes.string,
	entityUID: PropTypes.string,
}

function mapStateToProps(state) {
	return {
		codes: state.binders.codes,
		dateFormat: state.binders.dateFormat,
		timeFormat: state.binders.timeFormat,
		actualTimestamp: state.binders.actualTimestamp,
	}
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		closeModal: binderActions.closeCodesModal,
	}, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(BinderLessonCodesModal)
